export default {
    사이트명: "Damibang",
    사업명: "Damibang",
    신동원: "Shin Dong-won",
    "395-09-02501": "395-09-02501",
    "010-2345-8499": "+82 10-2345-8499",
    addressTxt: "102-ho, 7, Hyanggyo-ro hongmun-gil, Yeonpung-myeon, Goesan-gun, Chungcheongbuk-do, Republic of Korea",
    emailTxt: "kevin1327@naver.com",

    en: {
        Login: "Sign In",
        Logout: "Sign Out",
        Join: "Sign Up",
        Mypage: "My page",
    },

    // header, 회원
    "모바일 메뉴 열기": "Open",
    "모바일 메뉴 닫기": "Close",
    "홈으로 이동": "Go to Home",
    로그인: "Sign In",
    로그아웃: "Sign Out",
    회원가입: "Sign Up",
    마이페이지: "My Page",
    회원정보수정: "My Info",
    "자주 묻는 질문": "FAQs",
    공지사항: "Notice",
    "1:1 문의": "1:1 Support",
    개인정보: "My Data",
    개인정보처리방침: "Privacy Policy",
    이용약관: "Terms of Use",
    "관리자 문의": "Administrator inquiry",
    "아이디 저장": "Save ID",
    "아이디/비밀번호 찾기": "Find User Name / Password",
    "아이디 찾기": "Find User Name",
    "비밀번호 찾기": "Find Password",
    "회원가입이 완료되었습니다": "Registration successful.",

    // footer
    대표이사: "CEO",
    사업자등록번호: "Business registration number",
    문의번호: "Tel",
    주소: "Address",

    // 버튼
    찾기: "Find",
    검색: "Search",
    취소: "Cancel",
    등록: "Submit",
    다음: "Next",
    글쓰기: "Writing",
    저장하기: "Save",
    수정하기: "Edit",
    삭제하기: "Delete",
    "자세히 보기": "View More",
    내용보기: "View Content",
    가입하기: "Submit",
    문의하기: "Submit",
    인증요청: "Verify Identity",
    본인인증: "Verify Identity",
    인증완료: "Verification Successful",
    "확인하러 가기": "View in the List",
    "로그인하러 가기": "Sign In",

    // form
    아이디: "User Name",
    비밀번호: "Password",
    "비밀번호 확인": "Repeat password",
    이름: "Name",
    이메일: "E-mail",
    연락처: "Contact",
    내용: "Content",
    "문의 내용": "Inquiry",
    사업자등록증: "Registration of business",
    재직증명서: "Certificate of Employment",
    국가선택: "Select a country",
    수신동의: "{txt} agree to receive",
    국문: "Korean",
    영문: "English",
    한자: "Chinese",
    agree: {
        필수: "Required",
        선택: "Optional",
    },

    // placeholder, label
    선택: "Select",
    "을 입력하세요": "Enter @.lower:{txt}",
    "를 입력하세요": "Enter @.lower:{txt}",
    "검색어를 입력하세요": "Enter keyword.",
    "전화번호를 입력하세요": "Please enter your phone number.",
    "인증번호를 입력하세요": "Enter verification code.",
    "이름을 입력하세요": "Please enter your name.",
    "이름 또는 기관명을 입력하세요": "Enter your name or name of institution you work for.",
    "이메일을 입력하세요": "Enter e-mail address.",
    "내용을 입력하세요": "Enter texts.",
    "문의 내용을 입력하세요": "Enter texts.",
    "파일을 첨부하세요": "Attach a file.",
    "‘-’를 제외하고 입력하세요": "Enter a string of numbers that does not include hyphens (-).",
    "필수 입력 항목입니다": "Required entries.",
    "인증절차를 진행해주세요": "Please proceed with the authentication process.",
    "아이디 찾기를 위해 등록된 핸드폰 번호를 입력해주세요": "Enter contact that you have submitted to us when signing up.",
    "영문, 숫자 포함 5자 이상 입력해주세요": "Please enter at least 5 characters including letters and numbers.",
    "영문, 숫자 5자 이상 작성해주세요": "Please write at least 5 letters and numbers.",
    "영문, 숫자, 특수기호 포함 8자 이상 입력해주세요": "Please enter at least 8 characters including letters, numbers, and special symbols.",
    "비밀번호를 입력하세요": "Enter password.",
    "동일한 비밀번호를 재입력하세요": "Enter password again.",
    "비밀번호 찾기를 위해 등록된 핸드폰 번호를 입력해주세요": "Enter contact that you have submitted to us when signing up.",
    "자 이내": "that must not exceed {num} characters",
    이하: "up to {num}",
    "약관에 전체 동의합니다": "I agree to all terms and conditions below.",

    // alert
    "로그아웃 하시겠습니까?": "Do you want to log out?",
    "로그아웃 되었습니다": "You have been logged out.",

    // 게시판
    번호: "No",
    제목: "Title",
    작성자: "Writer",
    작성일: "Date",
    조회수: "Hit",
    상태: "Status",
    답변대기: "Waiting for reply",
    답변완료: "Answer complete",

    // 결제
    신용카드: "Credit Card",
    무통장입금: "Deposit without passbook ",
    카카오페이: "Kakaopay",

    // page text
    "오시는 길": "Location",
    제로장: "ZERO ZANG",
    케이장: "K ZANG",
    "떡볶이의 꿈": "DREAM OF TTEOKBOOKKI",
    개요: "Company",
    비전: "Company Vision",
    zeroZang: {
        tag: "#Zero Suger #Low calorie #Low salt",
        txt: "Zero Zang is developed<br>for people who care of diet and health care",
        txt2: "Gochujang specially developed for those who <br class='d-none d-xl-block'> are important to diet or health management",
    },
    kZang: {
        tag: "#Traditional Gochujang",
        txt: "low salt Gochujang with unique flavor, <br>made of traditional Gochujang ingredients",
        txt2: "Using traditional Korean red pepper paste ingredients, it preserves the unique flavor and reduces calories and salt content. <br class='d-none d-xl-block'>New concept of Gochujang",
    },
    DOT: {
        tag: "#Premium sauce",
        txt: "highest quality  sauce for making Tteokbokki, <br>Low-calorie premium sauce with the best taste",
        txt2: "A low-calorie tteokbokki sauce that delivers the best taste by generously <br class='d-none d-xl-block'>using the highest quality ingredients.<br class='d-none d-xl-block'>Premium sauce (sauce for stew, stir-fry)",
    },

    // page btn

    // page placeholder, label

    // gnbs
    회사소개: "Company",
    고추장이야기: "Gochujang Story",
    "고추장 이야기": "Gochujang Story",
    제품소개: "Product introduction",

    // 회원가입
    국내회원: "Local Member",
    개인회원: "Private Member",
    단체회원: "Institution Member",
    "국내 개인회원": "As a Local Member (Private)",
    "국내 단체회원": "As a Local Member (Institution)",
    "해외거주 회원": "International Member",
    "국내 개인 회원가입": "Sign Up (Private)",
    "국내 단체 회원가입": "Sign Up (Institution)",
    "국내 거주자 회원가입": "Sign Up (Domestic)",
    "해외거주자 회원가입": "Sign Up (International)",

    // 마이페이지

    // Page
    visual1: {
        tit: "<span class='d-inline-block mb-6px mb-md-8px'>Make a  healthy food <br class='d-none d-md-block'> on your dinning table</span><br>",
        txt: "Until the day when our food is loved by everyone around the world <br class='d-none d-md-block'>and placed on the tables of every home. <br>We will surve you trust by using only 100% Korean raw materials."
    },
    main: {
        section1: "Our product story",
        section2: "Stories of people who create a healthy food culture",
        story1: "We are creating <br class='d-none d-sm-block' /><span class='font-weight-extrabold'>a healthy food culture</span>",
        story2: "We are trying to develop <br class='d-none d-sm-block' /><span class='font-weight-extrabold'>food development process</span> and <br class='d-none d-sm-block' /><span class='font-weight-extrabold'>technical achievement</span> <br class='d-none d-sm-block' />for serving healthy food",
        story3: "Leading K-food to <span class='font-weight-extrabold'>globalization</span> <br class='d-none d-sm-block' />Becoming a global company.",
    },
    company: {
        tit: "With the belief that we must develop representing Korean spicy sauce <br class='d-none d-xl-block'> which is loved by everyone in the world",
        txt: "Traditional Korean sauce is used within 500 years of Korean history. Now, with the Korean Wave boom, we have entered a global era where people from all over the world can enjoy Korean food together"
    },
    vision: {
        num01: "Thorough quality control system",
        num01Txt: "We carefully select the highest quality Koreandomestic ingredients.We care about our customers’ health through a thorough quality control system. We will only make fresh and safe products.",

        num02: "Ongoing research and development",
        num02Txt: "to let customers Experience not only Korean cuisine but also various cuisines from around the world, We provide innovative and creative creative products.",

        num03: "Best customer service",
        num03Txt: "By providing collaborative products and services to customers. We will strive for trust and satisfaction.",

        num04: "Contribution to environmental protection",
        num04Txt: "Sustainable production and responsibility for the global environment. We will strive to contribute to protecting the global environment through our packaging methods."
    },
    story1: {
        tit: "K-Sauce globalization",
        txt: "Times have changed, and in the era of globalization, the <br class='d-none d-xl-block' />Korean Wave is in full swing, and K-Food is also <br class='d-none d-xl-block' />entered the world, and it is time for K-Sauce  becoming a <br class='d-none d-xl-block' />global sauce.",
    },
    story2: {
        tit: "K-Hot Sauce Development",
        txt: "Accordingly, we use red pepper paste, which is standardized <br class='d-none d-xl-block' />in Korean cuisine, in any cuisine in the world. <br class='d-none d-xl-block' />An innovative product that maintains the traditional taste and expands its uses to suit <br class='d-none d-xl-block' />We developed Korea's representative K-Hot Sauce.",
    },
    story3: {
        tit: "500 years of traditional red pepper paste",
        txt: "Our traditional red pepper paste has been used by our <br class='d-none d-xl-block' />ancestors to add spicy flavor to Korean food for 500 years. <br class='d-none d-xl-block' />This is a representative paste that has been used to produce <br class='d-none d-xl-block' />a rich aroma. Still every year <br class='d-none d-xl-block' />We continue the custom of making new soybeans every spring.",
    },
    story4: {
        tit: "Gochujang with customers’ health",
        txt: "We lower the salt content and innovatively reduce calories to <br class='d-none d-xl-block' />improve the health of our customers. <br class='d-none d-xl-block' />We create traditional products that can be used conveniently <br class='d-none d-xl-block' />and hygienically. <br class='d-none d-xl-block' />We are taking the lead in modernizing. Now loved by everyone in the world <br class='d-none d-xl-block' />We use only 100% domestic raw materials until the day it is placed on the table at home. <br class='d-none d-xl-block' />We will trust you.",
    },
}
